import { constantCreator } from '~/utils/constantsCreator';
import api from '~/utils/api';

const constant = constantCreator('city');
const GET_CITY = constant('GET_CITY', true);
const LOG_CLICK_BREAKPOINT = constant('LOG_CLICK_BREAKPOINT');

const initialState = {
  isLoading: true,
  isError: false,
  cityInfo: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CITY.PENDING:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case GET_CITY.RESOLVED: {
      return {
        ...state,
        isLoading: false,
        cityInfo: action.data,
      };
    }
    case GET_CITY.REJECTED: {
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const actions = {
  getCity: (city, date = new Date().toISOString()) => ({
    type: GET_CITY,
    promise: api.get(`/experience/home?city=${city}&date=${date}`),
  }),
  logClickBreakpoint: (city) => ({
    type: LOG_CLICK_BREAKPOINT,
    city,
  })
};

export const analytics = {
  [LOG_CLICK_BREAKPOINT]: action => ({
    name: 'Click breakpoint learn more',
    category: 'city',
    providers: 'database',
    city: action.city,
    activity: action.activity
  })
};
